export default __webpack_public_path__ + "static/media/white-tick.c7ebeacf.svg";